<div class="container" *ngIf="cargoFeatures?.isMobileApp" style="text-align: center; padding-top: 25px;">

        <div class="flex">
                <qr-code value="{{otpCode}}" size="300" errorCorrectionLevel="M" class="mx-auto"></qr-code>
        </div>

        <div class="otpCode" *ngIf="otpCode">Your code: {{otpCode}}</div>

        <p-button label="Получить код" (click)="createOTPCode()"></p-button>

        <div class="pt-8">Скачать приложение:</div>
        <div class="pt-2"><i class="pi pi-android"></i> <a target="_blank" href="https://play.google.com/store/apps/details?id=com.aussieman.anytrack_mobile">Android</a></div>
        <div class="pt-2"><i class="pi pi-apple"></i> <a target="_blank" href="https://apps.apple.com/kz/app/anytrack-mobile/id6448641889">iOS</a></div>
</div>